import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Styles
import './classes.scss';

// Components
import SelectLabel from '../select-label/select-label';
import GenericModal from '../generic-modal/generic-modal';
import EditClass from './edit-class';
import Button, { BUTTON_STYLES } from '../../components/button/button';
import ThreeEssentailsButton from '../../components/three-essentails-button/three-essentails-button';
import useIsOneRosterActivatedSchool from '../../hooks/use-is-one-roster-activated-school';
import Resources from '../../helpers/resources';

function Classes({
    classes,
    productId,
    currentClassName,
    currentClassId,
    updateCurrentClassId,
    editClassName,
    setIsMinimised,
    externalClassroomId,
    isSisSchool
}) {
    const { i18n } = useLocalisation();
    const isOneRosterActivatedSchool = useIsOneRosterActivatedSchool();
    // States
    const [isSelectDropdownDisabled, setIsSelectDropdownDisabled] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // Handlers
    const classDropdownOnChangeHandler = async (e) => {
        const classId = parseInt(e.target.value, 10);
        await setIsSelectDropdownDisabled(true);
        await updateCurrentClassId({ productId, classId });
        await setIsSelectDropdownDisabled(false);
        setIsMinimised(false);
    };
    const showEditModal = () => {
        setShowModal(!showModal);
    };

    const onOneRosterEditHandler = async () => {
        await Resources.getConfigurationItem('THREE_ESSENTIALS_MANAGE_CLASSES').then((manageClassesUrl) => {
            window.open(`${manageClassesUrl}uid/${externalClassroomId}/edit`);
        });
    };

    const getEditClassModal = () => {
        if (showModal) {
            return (<GenericModal
                title={<Trans id="Class Dropdown - edit title" />}
                closeHandler={showEditModal}>
                <EditClass
                    currentClassName={currentClassName}
                    currentClassId={currentClassId}
                    editClassName={editClassName}
                    closeHandler={showEditModal}
                />
            </GenericModal>);
        }
        return null;
    };

    const getThreeEssentailsButton = () => {
        if (isSisSchool !== false) return null;

        if (isOneRosterActivatedSchool) {
            return (<ThreeEssentailsButton
                clickHandler={onOneRosterEditHandler}
                title={<Trans id="Class Dropdown - edit title" />}
                show3EIcon={false}
                buttonClassName={'edit_class_name'}
            />);
        }
        return (
            <Button
                buttonStyle={BUTTON_STYLES.iconSVG}
                importedClasses="button--classes"
                iconName="edit"
                callback={showEditModal}
                ariaProps={
                    {
                        'aria-label': i18n._(t`Class Dropdown - edit title`)
                    }
                }
            />
        );
    };

    const hasClasses = classes && classes.length > 0;

    return (
        <React.Fragment>
            <SelectLabel
                propertyName="classId"
                value={currentClassId}
                isSelectDisabled={isSelectDropdownDisabled}
                selectHandler={classDropdownOnChangeHandler}
                listOfOptions={classes}
                id="consoleClassSelector"
                importedClasses="select--classes"
            />
            {
                hasClasses ?
                    <div className="classes__button-container">
                        { getThreeEssentailsButton()}
                        { getEditClassModal()}
                    </div> :
                    null
            }
        </React.Fragment>
    );
}

Classes.propTypes = {
    classes: PropTypes.array,
    productId: PropTypes.string,
    currentClassName: PropTypes.string,
    currentClassId: PropTypes.number,
    editClassName: PropTypes.func,
    updateCurrentClassId: PropTypes.func,
    setIsMinimised: PropTypes.func,
    externalClassroomId: PropTypes.string,
    isSisSchool: PropTypes.bool
};

export default Classes;



// WEBPACK FOOTER //
// ./components/classes/classes.js